import type { Product } from '@/storage/products'
import { ref } from 'vue'

export const productAssociated = ref<Product[]>([])
